/** How many tasks this host runs at once, for a `make -j` or a worker pool. */
export const CpuCount = (): number => navigator.hardwareConcurrency
